import { formatCurrency } from './index';

const orderStatusMap = {
  pending: 'Pending',
  processing: 'Processing',
  completed: 'Completed',
  cancelled: 'Cancelled',
  in_transit: 'In Transit',
  out_for_delivery: 'Out for Delivery',
  delivered: 'Delivered',
}

export const getOrderStatus = (status) => {
  return orderStatusMap[status] || 'Unknown'
}

export const getStatusClass = (status) => {
  const classes = {
    pending: 'bg-yellow-100 text-yellow-800 dark:bg-yellow-900 dark:text-yellow-200',
    processing: 'bg-blue-100 text-blue-800 dark:bg-blue-900 dark:text-blue-200',
    completed: 'bg-green-100 text-green-800 dark:bg-green-900 dark:text-green-200',
    cancelled: 'bg-red-100 text-red-800 dark:bg-red-900 dark:text-red-200',
  }
  return classes[status] || 'bg-gray-100 text-gray-800 dark:bg-gray-900 dark:text-gray-200'
}

export const columns = [
  {
    key: 'id',
    label: 'Order ID',
    format: (item) => `#${item.id}`,
    width: '100px',
  },
  {
    key: 'customer',
    label: 'Customer',
    format: (item) => item.customer?.name || 'N/A',
  },
  {
    key: 'business',
    label: 'Business',
    format: (item) => item.business?.name || 'N/A',
  },
  {
    key: 'total_amount',
    label: 'Amount',
    format: (item) => formatCurrency(item.total_amount),
  },
  {
    key: 'status',
    label: 'Status',
  },
]
